interface SectionHeaderProps {
  title: string;
  actions?: React.ReactNode;
}

export function SectionHeader({ title, actions }: SectionHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-lg font-medium">{title}</h3>
      {actions && <div className="flex items-center space-x-2">{actions}</div>}
    </div>
  );
}

